import React, { useState } from 'react';
import "./NewLoginFull.css";
import NewLoginForm from "@/react_app/NewAuth/NewLoginForm/NewLoginForm";
import NewLoginSocials from "@/react_app/NewAuth/NewLoginSocials/NewLoginSocials";
import NewRestorePasswordDialog from "@/react_app/NewAuth/NewRestorePasswordDialog/NewRestorePasswordDialog"
import {Button} from "primereact/button";

export default function(props){
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [visibleRestorePassword, setVisibleRestorePassword] = useState(false);

  const handleSignIn = () => {
    if (props.signIn) {
      props.signIn({ email, password });
    } else if (props.register) {
      props.register({ email, password });
    }
  };

  return(
    <div className={'login-full'}>
      <p className={'loginText'}>Login</p>
      <NewLoginSocials action={'login'} onConnect={props.handleUserConnect} userType={props.userType} connecting={props.connecting}/>
      <NewLoginForm setPassword={setPassword} setEmail={setEmail}/>
      <Button label={"SIGN IN"} className={'signInButton'} onClick={handleSignIn}/>
      <p className={'forgotPasswordText'}>Forgot your password? <span className={'redUnderlineText'} onClick={() => setVisibleRestorePassword(true)}>Restore</span></p>
      <p className={'newAccountText'}>Don’t have an account?</p>
      <p className={'redUnderlineTextCapital'} onClick={() => props.handleRouting('auth/register')}>Register</p>
      <NewRestorePasswordDialog visible={visibleRestorePassword} onHide={() => setVisibleRestorePassword(false)}/>
    </div>
  )
}
